import * as tslib_1 from "tslib";
import { BehaviorSubject, of } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
/**
 * @see https://blog.angular-university.io/angular-material-data-table/
 *
 * NB
 * If you need to change this to make a new DataSource
 * just change the following:
 *
 * - Change The class name in the first line
 * - Change DataSource<T> (use your model type) in first line
 * - Change BehaviourSubject<T> in the second line
 * - Change the service inside the class constructor
 * - Change the Observable<T> used in the connect() line
 * - Change the service name inside loadItems()
 */
var SuppliersNewDataSource = /** @class */ (function () {
    /**
     * Class constructor
     */
    function SuppliersNewDataSource(suppliersService, helperService, onlyNewInTank, translateService) {
        this.suppliersService = suppliersService;
        this.helperService = helperService;
        this.onlyNewInTank = onlyNewInTank;
        this.translateService = translateService;
        this.itemsSubject$ = new BehaviorSubject([]);
        this.totalCountSubject$ = new BehaviorSubject(0);
        this.totalActiveCountSubject$ = new BehaviorSubject(0);
        this.loadingSubject$ = new BehaviorSubject(true);
        this.loading$ = this.loadingSubject$.asObservable();
        this.totalCount$ = this.totalCountSubject$.asObservable();
        this.totalActiveCount$ = this.totalActiveCountSubject$.asObservable();
    }
    /**
     * Connect data table to itemsSubject$
     *
     * @since 1.0.0
     *
     * @param collectionViewer collection viewer object
     * @returns Observable
     */
    SuppliersNewDataSource.prototype.connect = function (collectionViewer) {
        return this.itemsSubject$.asObservable();
    };
    /**
     * Disconnect data table from subjects
     *
     * @since 1.0.0
     *
     * @param collectionViewer collection viewer object
     */
    SuppliersNewDataSource.prototype.disconnect = function (collectionViewer) {
        this.itemsSubject$.complete();
        this.totalCountSubject$.complete();
        this.totalActiveCountSubject$.complete();
        this.loadingSubject$.complete();
    };
    /**
     * Load items from back-end using service injected in the constructor
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering objects with filtering data
     * @param [master] Only users associated to master company
     */
    SuppliersNewDataSource.prototype.loadItems = function (start, limit, sort, sortVersus, search, master, allMasters) {
        var _this = this;
        this.loadingSubject$.next(true); // Start loading
        if (!search || !search.types || !search.types.includes("supplier")) {
            search.types = ["supplier"];
        }
        if (typeof this.onlyNewInTank !== "undefined" && this.onlyNewInTank) {
            this.suppliersService
                .getNewSuppliersInTank(start, limit, sort, sortVersus, search)
                .pipe(catchError(function (err) {
                // If errors, return empty array
                _this.helperService.handleError(err);
                return of({ status: true, data: [], totalCount: 0 });
            }), finalize(function () { return _this.loadingSubject$.next(false); }) // Stop loading on finalize
            )
                .subscribe(function (result) {
                _this.itemsSubject$.next(result.data);
                _this.totalCountSubject$.next(result.totalCount);
                if (typeof result.totalCount !== "undefined") {
                    _this.totalActiveCountSubject$.next(result.totalCount);
                }
            });
        }
        else {
            this.suppliersService
                .getListV2(start, limit, sort, sortVersus, search, master, allMasters)
                .pipe(catchError(function (err) {
                // If errors, return empty array
                _this.helperService.handleError(err);
                return of({ status: true, data: [], totalCount: 0 });
            }), finalize(function () { return _this.loadingSubject$.next(false); }) // Stop loading on finalize
            )
                .subscribe(function (result) {
                if (result.data && Array.isArray(result.data)) {
                    result.data.forEach(function (item) {
                        var e_1, _a, e_2, _b;
                        if (item.ownDocuments && Array.isArray(item.ownDocuments)) {
                            try {
                                for (var _c = tslib_1.__values(item.ownDocuments), _d = _c.next(); !_d.done; _d = _c.next()) {
                                    var doc = _d.value;
                                    if (doc.type === "durc" || doc.type === "exemptionDurc") {
                                        item.durc = doc;
                                    }
                                    if (doc.type === "registration") {
                                        item.registration = doc;
                                    }
                                    if (doc.type === "exemptionPac") {
                                        item.creditLicence = doc;
                                    }
                                    if (doc.type === "pac" || doc.type === "soa") {
                                        item.creditLicence = doc;
                                        item.credits = doc.credits;
                                    }
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                        }
                        if (item.categories && Array.isArray(item.categories)) {
                            var categories = "";
                            try {
                                for (var _e = tslib_1.__values(item.categories), _f = _e.next(); !_f.done; _f = _e.next()) {
                                    var category = _f.value;
                                    var catTranslated = _this.translateService.instant("suppliers.categories." + category);
                                    categories = categories !== "" ? categories + "," : "";
                                    categories = categories + " " + catTranslated;
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                            item.categories.length = 0;
                            item.categories.push(categories);
                        }
                        if (item.legalAddress &&
                            (item.legalAddress.city ||
                                item.legalAddress.administrativeArea2)) {
                            item.municipalityProvince = item.legalAddress.city
                                ? item.legalAddress.city
                                : "";
                            item.municipalityProvince = item.municipalityProvince + " " + (item.legalAddress.administrativeArea2
                                ? item.legalAddress.administrativeArea2
                                : "");
                        }
                    });
                }
                _this.itemsSubject$.next(result.data);
                _this.totalCountSubject$.next(result.totalCount);
                if (typeof result.totalCount !== "undefined") {
                    _this.totalActiveCountSubject$.next(result.totalCount);
                }
            });
        }
    };
    /**
     * Load items from back-end using service injected in the constructor
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering objects with filtering data
     * @param [master] Only users associated to master company
     */
    SuppliersNewDataSource.prototype.loadOnlyNfcItems = function (start, limit, sort, sortVersus, search) {
        var _this = this;
        this.loadingSubject$.next(true); // Start loading
        this.suppliersService
            .getListVOnlyNfc(start, limit, sort, sortVersus, search)
            .pipe(catchError(function (err) {
            // If errors, return empty array
            _this.helperService.handleError(err);
            return of({ status: true, data: [], totalCount: 0 });
        }), finalize(function () { return _this.loadingSubject$.next(false); }) // Stop loading on finalize
        )
            .subscribe(function (result) {
            _this.itemsSubject$.next(result.data);
            _this.totalCountSubject$.next(result.totalCount);
        });
    };
    return SuppliersNewDataSource;
}());
export { SuppliersNewDataSource };
